// @flow

import { useDispatch } from 'react-redux';
import { useState } from 'react';
import DevicesDataGrid from 'insight/components/datagrid/farmer/DevicesDataGrid';
import PageContainer from 'insight/pages/common/PageContainer';
import FarmerAppDevicesTabNavigation from 'insight/pages/farmerapp/FarmerAppDevicesTabNavigation';
import { getTbFarmerDevicesByTypeWithTelemetry } from 'insight/api/ThingsboardApiService';
import { TB_FARMER_DEVICE_TYPE_VALUE_ENUM } from 'insight/constants/ThingsboardConstants';
import { FARMER_DEVICE_TAB_NAVIGATION_ENUM } from 'insight/constants/DeviceConstants';
import type { TbFarmerDeviceType } from 'insight/types/Thingsboard.types';
import PageTitle from '../../../common/components/PageTitle';

const FarmerAppDevices = (): React$Node => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [tabSelected, setTabSelected] = useState(null);

  const fetchDevices = (devicesToFetch: Array<TbFarmerDeviceType>) => {
    getTbFarmerDevicesByTypeWithTelemetry(dispatch, devicesToFetch, null).then((response) => {
      setItems(response);

      if (devicesToFetch.includes(TB_FARMER_DEVICE_TYPE_VALUE_ENUM.SENSOR_SPEAR)) {
        setTabSelected(FARMER_DEVICE_TAB_NAVIGATION_ENUM.SENSOR_SPEAR);
      } else {
        setTabSelected(FARMER_DEVICE_TAB_NAVIGATION_ENUM.GRAIN_ANALYZERS);
      }
    });
  };

  return (
    <PageContainer>
      <PageTitle titleKey={'app.page.title.farmerApp.devices'} />
      <FarmerAppDevicesTabNavigation fetchDevices={fetchDevices} />
      <DevicesDataGrid items={items} tabSelected={tabSelected} fetchDevices={fetchDevices} />
    </PageContainer>
  );
};

export default FarmerAppDevices;
